var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { CircleIcon } from './circle-icon';
export var ShareCircleIcon = function ShareCircleIcon(props) {
  return React.createElement(CircleIcon, __assign({}, props, {
    viewBox: "0 0 20 20"
  }), React.createElement("path", {
    d: "M10 1.73913C14.5652 1.73913 18.2609 5.43478 18.2609 10C18.2609 14.5652 14.5652 18.2609 10 18.2609C5.43478 18.2609 1.73913 14.5652 1.73913 10C1.73913 5.43478 5.43478 1.73913 10 1.73913ZM10 0C4.47826 0 0 4.47826 0 10C0 15.5217 4.47826 20 10 20C15.5217 20 20 15.5217 20 10C20 4.47826 15.5217 0 10 0Z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 8.75001L11.2724 13.75V11.2591C8.12488 10.6107 5.63846 11.3255 3.75 13.7063C4.07785 8.8098 7.44124 6.44688 11.2723 6.29046L11.2724 3.75L16.25 8.75001Z"
  }));
};